export const ACCESS_LEVEL_ACCESS = {
    CREATOR: 1,
    ADMIN: 2,
    EDIT: 3,
    VIEW: 4
};
